module.exports = __webpack_public_path__ + "img/ic_discipline.6425c229.svg";